export default __webpack_public_path__ + "static/media/second-opi-circle-img.2b46df8f.png";